<template><g class="SelectorG" :class="statusClass()">

    <rect @click.stop.prevent="detail_click" v-bind="props.cabAttrs" class="cabin"></rect>
    <text class="cabin_num" v-bind="props.numAttrs" v-text="props.numAttrs.text"></text>
    <text class="cabin_vacancies" v-bind="props.vacAttrs">{{isBooked() ? gostey(occupation) : mest()}}</text>

    <foreignObject v-if="isFree(props.Cabin)" width="1" height="1">
        <RoomModal :Cabin="props.Cabin" :CabinSet="props.CabinSet" 
            :modalShown="isModalShown" @input="set_isModalShown" />
    </foreignObject>

</g></template>


<script setup>
import {ref, unref, computed, onMounted, watch, nextTick} from 'vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import { numWord } from '@/util.js'
import {isFree} from '@/comp/useCruiseBook.js'
import RoomModal from './RoomModal.vue'

const cstore = useCruiseStore()
const bookCabins = useCabinsStore()

const props = defineProps({
    Cabin : Object,
    CabinSet : Object,
    cabAttrs : Object,
    vacAttrs : Object,
    numAttrs : Object,
})

const isModalShown = ref(false)
const set_isModalShown = nov => isModalShown.value = nov
const detail_click = () => {
    if (isFree(props.Cabin)) {
        isModalShown.value = true
    }
}


const occupation = bookCabins.getOccupation( props.Cabin.id )

const isBooked = () => bookCabins.isBooked( props.Cabin.id )

/*
будет размещено 5 человек
размещено 5
2 места (+1)
5 гостей
*/
const gostey = ({adult, child, infant}) => {
    const num = adult+child+infant
    const ret = `${num}ч`
//    const ret = numWord(num, ['ч', 'ч', 'ч'])
    return ret
}


const statusClass = () => {
    let cli = isFree(props.Cabin) ? 'free' : 'busy'
    let book = isBooked() ? 'prebook' : ''
    let last = unref(isModalShown) ? 'last' : ''
    const ret = `${cli} ${book} ${last}`
    return  ret
}

const mest = () => {
    let { main, additional }  = props.Cabin.acc
    let addi = additional > 0 ? `+${additional}` : ''
    const ret = `${main}${addi}`
    return ret
}


</script>
